import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import './index.css';

const Refer = ({
  setShowHideHeader,
  setshowHideFooter,
  setshowHideinnerFooter
}) => {
  const [customerInfo, setCustomerInfo] = useState({
    email: '',
    firstName: '',
    lastName: ''
  });

  useEffect(() => {
    setShowHideHeader(true);
    setshowHideFooter(true);
    setshowHideinnerFooter(false);

    // Get customer info from URL parameters or localStorage
    const urlParams = new URLSearchParams(window.location.search);
    const email = urlParams.get('email') || localStorage.getItem('customerEmail') || '';
    const firstName = urlParams.get('firstName') || localStorage.getItem('customerFirstName') || '';
    const lastName = urlParams.get('lastName') || localStorage.getItem('customerLastName') || '';

    setCustomerInfo({ email, firstName, lastName });

    // Store in localStorage for future visits
    if (email) localStorage.setItem('customerEmail', email);
    if (firstName) localStorage.setItem('customerFirstName', firstName);
    if (lastName) localStorage.setItem('customerLastName', lastName);

    // Load ReferralCandy widget script
    if (!document.getElementById('refcandy-candyjar-js')) {
      const script = document.createElement('script');
      script.id = 'refcandy-candyjar-js';
      script.src = '//portal.referralcandy.com/assets/widgets/refcandy-candyjar.js';
      script.async = true;
      document.body.appendChild(script);
    }
  }, [setShowHideHeader, setshowHideFooter, setshowHideinnerFooter]);

  return (
    <div className="refer-page">
      <Helmet>
        <title>Share & Earn Rewards - BlueBox Rent</title>
        <meta name="description" content="Share BlueBox with friends and earn rewards! Get your referral link and start earning today." />
      </Helmet>

      <Container>
        <Row className="justify-content-center">
          <Col lg={10} md={12}>
            <div className="refer-header text-center mb-5">
              <h1 className="refer-title">Share BlueBox & Earn Rewards!</h1>
              <p className="refer-subtitle">
                {customerInfo.firstName ? `Hi ${customerInfo.firstName}! ` : 'Hi! '}
                Love your BlueBox experience? Share it with friends and family! 
                You&apos;ll both get rewards when they book their first rental.
              </p>
            </div>

            <Row>
              <Col md={12}>
                <div className="referral-widget-container">
                  {customerInfo.email ? (
                    <iframe
                      id="refcandy-candyjar"
                      data-id="ipko2p14a1kaj0p52kzg3qbee"
                      data-id-type="campaign"
                      data-height="900"
                      data-width="100%"
                      data-email={customerInfo.email}
                      data-fname={customerInfo.firstName}
                      data-lname={customerInfo.lastName}
                      frameBorder="0"
                      style={{ width: '100%', minHeight: '900px', border: 'none' }}
                      title="ReferralCandy Dashboard"
                    />
                  ) : (
                    <iframe
                      id="refcandy-candyjar"
                      data-id="ipko2p14a1kaj0p52kzg3qbee"
                      data-id-type="campaign"
                      data-height="900"
                      data-width="100%"
                      frameBorder="0"
                      style={{ width: '100%', minHeight: '900px', border: 'none' }}
                      title="ReferralCandy Widget"
                    />
                  )}
                </div>
              </Col>
            </Row>

            <Row className="mt-4">
              <Col md={12}>
                <div className="how-it-works-card">
                  <h3>How It Works</h3>
                  <Row>
                    <Col md={4} className="step">
                      <div className="step-number">1</div>
                      <h4>Share Your Link</h4>
                      <p>Send your referral link to friends and family who are planning a move</p>
                    </Col>
                    <Col md={4} className="step">
                      <div className="step-number">2</div>
                      <h4>They Book & Save</h4>
                      <p>Your friends get a special discount when they book their first BlueBox rental</p>
                    </Col>
                    <Col md={4} className="step">
                      <div className="step-number">3</div>
                      <h4>You Both Get Rewarded</h4>
                      <p>Once their rental is complete, you both receive exclusive rewards!</p>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>

            <Row className="mt-5">
              <Col md={12}>
                <div className="testimonial-section text-center">
                  <h4>Why Friends Love BlueBox</h4>
                  <div className="testimonial-grid">
                    <div className="testimonial-item">
                      <p>&quot;So convenient! Boxes delivered right to my door and picked up when I was done.&quot;</p>
                      <small>- Sarah M.</small>
                    </div>
                    <div className="testimonial-item">
                      <p>&quot;Made my office move so much easier. Professional service from start to finish.&quot;</p>
                      <small>- David L.</small>
                    </div>
                    <div className="testimonial-item">
                      <p>&quot;Great quality boxes and amazing customer service. Highly recommend!&quot;</p>
                      <small>- Maria R.</small>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

Refer.propTypes = {
  setShowHideHeader: PropTypes.func.isRequired,
  setshowHideFooter: PropTypes.func.isRequired,
  setshowHideinnerFooter: PropTypes.func.isRequired
};

export default Refer;